import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCollapseNavigationExternalLink, LazyCollapseNavigationHeader, LazyCollapseNavigationPdfGroup, LazyContentWrapper, LazyFlexTableCell, LazyFlexTableRow, LazyFlexTableStart, LazyHelpBubble, LazyIntrumentTag, LazyMusikumLogo, LazyStudentSelect, LazyThemeToggle, LazyToolbarAccountMenu, LazyFormsForgotPassword, LazyFormsPayer, LazyFormsResetPassword, LazyFormsStudent, LazyModalsAddressModal, LazyStepper, LazyTairoLogo, LazyTairoLogoText, LazyTairoToaster, LazyTairoTocAnchor, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["CollapseNavigationExternalLink", LazyCollapseNavigationExternalLink],
["CollapseNavigationHeader", LazyCollapseNavigationHeader],
["CollapseNavigationPdfGroup", LazyCollapseNavigationPdfGroup],
["ContentWrapper", LazyContentWrapper],
["FlexTableCell", LazyFlexTableCell],
["FlexTableRow", LazyFlexTableRow],
["FlexTableStart", LazyFlexTableStart],
["HelpBubble", LazyHelpBubble],
["IntrumentTag", LazyIntrumentTag],
["MusikumLogo", LazyMusikumLogo],
["StudentSelect", LazyStudentSelect],
["ThemeToggle", LazyThemeToggle],
["ToolbarAccountMenu", LazyToolbarAccountMenu],
["FormsForgotPassword", LazyFormsForgotPassword],
["FormsPayer", LazyFormsPayer],
["FormsResetPassword", LazyFormsResetPassword],
["FormsStudent", LazyFormsStudent],
["ModalsAddressModal", LazyModalsAddressModal],
["Stepper", LazyStepper],
["TairoLogo", LazyTairoLogo],
["TairoLogoText", LazyTairoLogoText],
["TairoToaster", LazyTairoToaster],
["TairoTocAnchor", LazyTairoTocAnchor],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
